export default {
  banner: {
    title: "Identity Automation",
    subtitle:
      "Authing Identity Automation platform provides a PaaS-based orchestration tool to help enterprises flexibly achieve automated identity governance.",
    data1: "Complex management needs met",
    data2: "Redundant construction costs cut",
    data3: "Data sync efficiency improved",
    data4: "Control process execution results",
    bg: "identify-automation-banner-en.png",
  },
  identifyReason: {
    title: "Why do we need Automated Identity Management?",
    subtitle1: `As an enterprise grows and the number of applications increases, disconnected identity data leads to inefficient and outdated data flow,`,
    subtitle2:
      "affecting upper-level business management efficiency and security.",
    tab1: "Automated Identity Management",
    tab2: "Non-automated Identity Management",
    bg1:
      "https://files.authing.co/authing-website/identify-automation-1-en.png",
    bg2: "https://files.authing.co/authing-website/identify-automation-2.png",
  },
  identifyEvent: {
    title: "Simplify identity governance through flexible orchestration",
    subtitle1: "Integrate multiple steps into one process",
    subtitle2: "Automatically synchronize data and manage identities",
    descript1:
      "Imagine when an employee joins, how many people, applications, steps, and time are needed to add them and grant permissions across systems? ",
    descript2:
      "Authing's Identity Automation Platform synchronizes data and manages identities across multiple applications with a single setup. ",
    descript3:
      "For example, during onboarding approval, the system automatically adds the employee, grants permissions, and sends notifications, streamlining operations and reducing security risks.",
  },
  identifyLayout: {
    title: "Rich templates + flexible code for more efficient workflow",
    subtitle1:
      "Authing integrates 400+ apps and offers nearly 80 templates to help businesses quickly achieve synchronization of identity data.",
    subtitle2:
      "In addition, Authing also offers ETL capabilities and workflow control capabilities, to improve development flexibility.",
    item1: {
      title: "Upstream data sync on Feishu",
      subtitle:
        "Pull the Feishu user and department lists and automatically sync data.",
    },
    item2: {
      title: "Upstream data sync on Windows AD",
      subtitle:
        "Pull the AD user and department lists and automatically sync data.",
    },
    item3: {
      title: "Upstream data sync on WeCom",
      subtitle:
        "Pull the WeChat Work user and department lists and automatically sync data.",
    },
    item4: {
      title: "Upstream data sync on DingTalk",
      subtitle:
        "Pull the DingTalk user and department lists and automatically sync data.",
    },
    item5: {
      title: "Upstream data sync on LDAP",
      subtitle:
        "Pull the LDAP user and department lists and automatically sync data.",
    },
    item6: {
      title: "Department creation sync on LDAP",
      subtitle:
        "Select a trigger, compare department data, and automatically create departments.",
    },
    item7: {
      title: "Department update sync on Moka",
      subtitle:
        "Select a trigger, compare department data, and automatically update departments.",
    },
  },
  identifyLog: {
    title: "More detailed logs, more controllable execution",
    subtitle:
      "Receive alarm, locate problems, and make corrections in real-time.",
    subtitle2:
      "Break the black box state and reasonably expect execution results.",
    descript1:
      "Automatically generate identity data views based on user configurations to clearly display business relationships.",
    descript2:
      "Provide runtime logs for enterprises to view the execution status, input and output parameters, facilitating debugging.",
    descript3:
      "Provide synchronization history to confirm the accuracy of synchronization content and results.",
    descript4:
      "Provide monitoring logs to record the logs of failed nodes during operation and issue alerts for abnormal results.",
  },
  identifyCustomer: {
    item1: {
      title: "A well-known optical system company",
      descript1:
        "Focuses on the R&D and manufacturing of precision optical systems.",
      subtitle: "Automated notifications",
      descript2:
        "We use Authing unified identity authentication and established an automation engine to ensure data security in our R&D lab and simplify notifications, allowing employees to quickly complete daily  work.",
    },
    item2: {
      title: "A Fortune 500 beverage company",
      descript1: "Holds a 48% global market share and has 160 beverage brands.",
      subtitle: "Automated data synchronization",
      descript2:
        "Integrating upstream identity sources with Authing allows us to manage identity data for over 20,000 employees in one system, reducing authorization lag and improving employee lifecycle management efficiency.",
    },
    item3: {
      title: "A leading domestic securities firm",
      descript1:
        "Its business covers securities brokerage, securities investment consulting and etc.",
      subtitle: "Automated permission allocation",
      descript2:
        "Authing's identity automation system replaced our outdated IDM system, ensuring compliance and meeting business needs by synchronizing data and assigning permissions automatically.",
    },
  },
};
